import React from "react";
import SchoolManager from "../SchoolManager";

// Reports wrapper component that renders SchoolManager with Reports tab pre-selected
// This allows Reports to be a standalone module while reusing existing SchoolManager code
const Reports = ({ onBack }) => {
  return <SchoolManager defaultTab="Reports" hideNavigation={true} onBack={onBack} />;
};

export default Reports;
